import { DEFAULT_RB_AI_DATA } from "./constants/constants";

const initialData = {
  resume: {
    active_color: "",
    custom_template_color: "",
    active_template: "template-one",
    sections_display_order: [],
    active_editor: 'traditional',
    heading: {
      name: "Contact Information",
      fname: "",
      lname: "",
      profession: "",
      profile_picture: {},
      address: "",
      city: "",
      state: "",
      country: "",
      zipcode: "",
      phone: "",
      email: "",
      address_visibility: 'yes',
      show_profile_picture: true
    },
    socials: {
      //init empty
      // facebook: {
      //     name: 'Facebook',
      //     link: ''
      // }
    },
    portfolio:{
      set: {
        'id_1': { label: '', link: '' },
      }, new: true
    },
    work_history: {
      name: 'Professional Experience',
      jobs: {
        job_1: {
          job: {
            job_title: "",
            employer: "",
            city: "",
            state: "",
            start_date: "",
            end_date: "",
            currently_working: false,
            description:
              "",
          },
        },
      },
      edit_in_progress: { job: "job_1", step: 1 },
    },
    education_history: {
      name: 'Education',
      all: {
        education_1: {
          education: {
            school_name: "",
            school_location: "",
            degree: "",
            field_of_study: "",
            start_date: "",
            end_date: "",
            currently_studying: false,
            description:
              "",
          },
        },
      },
      edit_in_progress: { education: "education_1", step: 1 },
    },
    summary: {content:''},
    skills: {
      name: 'Key Skills',
      set:{
      skill_1:{rating:0,name:''},
      },
      rating_disabled: false,
      rating_changed: false,
    },
    additional_sections: {
      custom:[]
    },
    enabled_tabs: ["heading"],
    current_tab: "heading",
    resume_name: '',
    created_date: '',
    modified_date: '',
    skipped_sections: [],
    finished_popup: true,
    job_category: '',
    styling: {
      headingStyle: {
        textColor: '',
        fontFamily: '',
        fontSize: ''
      },
      subHeadingStyle: {
        textColor: '',
        fontFamily: '',
        fontSize: ''
      },
      textStyle: {
        textColor: '',
        fontFamily: '',
        fontSize: ''
      }
    },
    heading_font_family: "",
    heading_font_size: "",
    heading_color: "",
    content_font_family: "",
    content_font_size: "",
    content_color: "",
  },
  enabled_tabs: ["heading"],
  current_tab: "education",
  next_label: "Next: Education",
  next_clicked: false,
  back_clicked: false,
  skip_clicked: false,
  skip_label: 'Skip',
  unskip_clicked: false,
  redirect_to: "",
  loginHash: null,
  user: null,
  job_category: "",
  scroll2_active_section: false,
  aidata: [],
  downloadFormat: 'pdf',
  has_plan: false,
  plan: null,
  plan_has_trial: false,
  plan_status: null,
  lastsync: 0,
  context_menu: true,
  default_plan_card_text: "1,497 people signed up for this today!",
  redirect_to: "/",
  has_profile_picture: false,
  coverletter: {
    from: {
      fname: "",
      addressline1: "",
      addressline2:"",
      phone: "",
      email: "",
    },
    summary: {
      content:"",
      date: "",
      hide_letter_date: false,
    },
    to: {
      fname: "",
      company: "",
      addresstoline1: "",
      addresstoline2:"",
      phone: "",
      email: "",
    },
    ques_ans_response: {
        job_details_provided: true,
        desired_position: "",
        desired_company: "",
        experience: "",
        skills_fetched_params: {job_details_provided: "", desired_position:'', datetime: ''},
        skills_list_displayed: [],
        skills: [],
        strengths: [],
        work_style: "",
        work_history: "",
    },
    qa_steps_initiated: false,
    ai_data_collected: false,
    generated_count: null,
    active_color: "",
    custom_template_color: "",
    active_template: "template-eleven",
    enabled_tabs: ["job-details"],
    current_tab: "job-details",
    letter_name: '',
    created_date: '',
    modified_date: '',
    skipped_sections: [],
    finished_popup: true,
    job_category: '',
    heading_font_family: "",
    heading_font_size: "",
    heading_color: "",
    content_font_family: "",
    content_font_size: "",
    content_line_spacing: "",
    content_color:"",
    login_action:false
  }
};

export default initialData;

